import { render, staticRenderFns } from "./StepQuestion.vue?vue&type=template&id=673f0f36"
import script from "./StepQuestion.vue?vue&type=script&lang=js"
export * from "./StepQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports